import React, {Component} from 'react';
import {
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    FormText, FormFeedback, CustomInput, Media
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DateInput from "react-datepicker";
import moment from "moment";
import {updateAffiliateStatus} from "../../../shared/redux/entities/actions";


class EditAffiliate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isUpdating: false,
            isActivating: false,
            hasEndDate: true,
            error: null,
            validateForm: false
        }
    }

    componentWillMount() {
        const {affiliate} = this.props
        if (affiliate) {
            this.setState({...affiliate,
                startDate: affiliate.startDate ? moment(moment.utc(affiliate.startDate).format('LL')).startOf('day') : moment(),
                endDate: affiliate.endDate ? moment(moment.utc(affiliate.endDate).format('LL')).startOf('day') : false,
                hasEndDate: !!affiliate.endDate,
                priority: affiliate.priority || 9,
                validateForm: true});
        } else {
            this.setState({
                name: '',
                startDate: moment(),
                endDate:  moment(this.state.startDate).add(7, "day"),
                url: '',
                mainText: '',
                terms: '',
                priority: 9
            });
        }
    }

    componentDidMount(){
    }


    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.affiliate && !this.props.affiliate){
            const {affiliate} = newProps
            this.setState({...affiliate,
                startDate: affiliate.startDate ? moment(moment.utc(affiliate.startDate).format('LL')).startOf('day') : moment(),
                endDate: affiliate.endDate ? moment(moment.utc(affiliate.endDate).format('LL')).startOf('day') : false,
                priority: affiliate.priority || 9,
                validateForm: true,
                isCreate: false});
        }
    }

    isValidAffiliate() {
        const {name, priority, hasEndDate, startDate, endDate, mainText, url, terms} = this.state
        return name && startDate && (!hasEndDate || hasEndDate && endDate && startDate < endDate) && mainText && url && terms && priority
    }

    handleSubmit(data) {
        console.debug("handleSubmit")
        if (!this.isValidAffiliate()) {
            this.setState({validateForm: true})
            return
        }
        const affiliate = this.props.affiliate || {}
        const {isCreate, loadAffiliates, brandId} = this.props
        const {name, priority, startDate, endDate, mainText, url, terms} = this.state
        const requestData = {
            ...(name !== affiliate.name && {name: name}),
            ...(priority !== affiliate.priority && {priority: priority}),
            ...((!affiliate.startDate || startDate.format('LL') !== moment.utc(affiliate.startDate).format('LL')) && {startDate: this.state.startDate.add(this.state.startDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...((!!affiliate.endDate && !endDate) && {endDate: null}),
            ...((!affiliate.endDate && endDate || endDate && affiliate.endDate && endDate.format('LL') !== moment.utc(affiliate.endDate).format('LL')) && {endDate: endDate.add(endDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...(mainText !== affiliate.mainText && {mainText: mainText }),
            ...(url !== affiliate.url && {url: url }),
            ...(terms !== affiliate.terms && {terms: terms }),
            ...(isCreate && {status: 'DRAFT'})
        }
        this.setState({isUpdating: true, error: null});
            if (this.props.isCreate) {
                this.props.createAffiliate({
                    brandId: brandId,
                    ...requestData
                })
                    // .then((res)=>res.instance.id)
                    .then((res) => {
                        return loadAffiliates()
                        .then(() => {
                            this.props.history.replace(`${this.getBackLink()}/${res.instance.id}`);
                        })
                    })
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updateAffiliate(this.props.affiliate.id, requestData)
                    .then((res) => {
                        if (affiliate.status ===  'ACTIVE' && endDate
                            && endDate.format('LL') === moment().format('LL')){
                            this.props.updateAffiliateStatus(affiliate.id, {status: 'ENDED'})
                        }
                        this.handleSuccess()
                    })
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updateAffiliate(this.props.affiliate.id, {status: 'ACTIVE'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdateLineUps: true}))
            .catch((err) => {
                console.log(err)
                try {
                    this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
                } catch (e) {
                    this.handleFailure({message: err.message.replace(/'/g, '"')})
                }
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.props.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.props.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    handleHasEndDateClick(event){
        this.setState({
            hasEndDate:event.target.checked,
            endDate:event.target.checked && this.state.startDate ? moment(moment.utc(this.state.startDate).clone().add(1,'weeks').format('LL')).startOf('day') : false
        });
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    render() {
        const {
            isCreate,
            affiliate,
        } = this.props;
        const {name, priority, startDate, endDate, mainText, url, terms, status} = this.state

        const {
            isUpdating,
            isActivating,
            hasEndDate,
            validateForm,
            error
        } = this.state;

        if (!isCreate && !affiliate) {
            return <div>Affiliate failed to load</div>
        }

        return (
            <Container className="EditAffiliate">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Affiliate' : `Edit ${affiliate.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Affiliate Internal Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.setState({ name: e.target.value})}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Affiliate Internal Name is required</FormFeedback> }
                                    <FormText>Affiliate internal name that is used for the reporting</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectPriority" sm={4}>Priority</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="selectPriority"
                                                 id='selectPriority'
                                                 defaultValue={priority}
                                                 invalid={(!priority || priority.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ priority: Number(e.target.value)})}>
                                        {[1,2,3,4,5,6,7,8,9].map((i) => (
                                            <option key={i} value={i}>{i}</option>
                                        ))}
                                    </CustomInput>
                                    <FormFeedback>Priority is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Priority defines sorting order for the user.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: d})}
                                    />
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should the affiliate start?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='endDate'>End Date</Label>
                                <Col sm={4}>
                                    <DateInput id='endDate'
                                               className='form-control'
                                               disabled={!startDate || !hasEndDate}
                                               minDate={startDate || moment().startOf("day")}
                                               selected={endDate}
                                               onChange={(d) => {
                                                   this.setState({endDate: d});
                                               } }
                                    />
                                    {hasEndDate && startDate >= endDate && validateForm &&
                                    <FormText color='danger'>End date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should the affiliate end?</FormText></Col></Row>
                                </Col>
                                <Col sm={4}>
                                    <FormGroup check>
                                        <Label id='HasEndDateCheckbox' check>
                                            <Input
                                                type='checkbox'
                                                checked={hasEndDate}
                                                onClick={(e) => this.handleHasEndDateClick(e)}
                                            />
                                            Has end date
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="mainText" sm={4}>Button Copy</Label>
                                <Col sm={8}>
                                    <Input name="mainText"
                                           id="mainText"
                                           defaultValue={mainText}
                                           maxLength={40}
                                           onChange={(e) => this.setState({ mainText: e.target.value})}
                                           invalid={(!mainText || mainText.length === 0) && validateForm}/>
                                    <FormFeedback>Button Copy is required</FormFeedback>
                                    <FormText>Affiliate button copy</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="terms" sm={4}>Call-to-Action Copy</Label>
                                <Col sm={8}>
                                    <Input name="terms"
                                           id="terms"
                                           type="textarea"
                                           defaultValue={terms}
                                           onChange={(e) => this.setState({ terms: e.target.value})}
                                           invalid={(!terms || terms.length === 0) && validateForm}/>
                                    <FormFeedback>Call-to-Action Copy is required</FormFeedback>
                                    <FormText>Call-to-Action Copy of the affiliate</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="url" sm={4}>Call-to-Action URL</Label>
                                <Col sm={8}>
                                    <Input name="url"
                                           id="url"
                                           type="url"
                                           defaultValue={url}
                                           onChange={(e) => this.setState({ url: e.target.value})}
                                           invalid={(!url || url.length === 0) && validateForm}/>
                                    <FormFeedback>Call-to-Action URL is required, ensure the url is correct.</FormFeedback>
                                    <FormText>Affiliate Call-to-Action URL</FormText>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidAffiliate()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditAffiliate;



// WEBPACK FOOTER //
// ./src/routes/EditAffiliate/components/EditAffiliate.js